export default "__VITE_ASSET__C1sQ42n4__"